angular.module('invoice')
    /* ngInject */
    .controller('InvoiceSettlementHistoryController', function ($http, $uibModalInstance, data) {
        this.$onInit = () => {
            if(data.invoiceId != null){
                $http.get('/crm/api/invoice-settlement-history/invoice/' + data.invoiceId).then(success => this.items = success.data);
            }
            else if(data.settlementId != null){
                $http.get('/crm/api/invoice-settlement-history/settlement/' + data.settlementId).then(success => this.items = success.data);
            }
        }

        this.close = () => $uibModalInstance.close('Canceled');
    });
